import Controller from '../abstracts/Controller';
import 'scss-templates/t-storelocator-detail.scss';

export default class StoreLocatorDetailController extends Controller {

  static get COMPONENTS() {
    return [
      'StoreLocatorDetailComponent',
      'PrintComponent',
      'DatePickerComponent',
      'BookingAptComponent',
      'VideoComponent'
    ];
  }


  init() {
    super.init();
  }

}
